import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-unauthorized401',
    templateUrl: './unauthorized401.component.html',
    styleUrls: ['./unauthorized401.component.scss', '../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class Unauthorized401Component implements OnInit {

  private router = inject(Router);

  constructor() { };

  ngOnInit(): void {
    localStorage.clear();
  }

  public Reload(): void {

    this.router.navigate(['']);

  }

}
